<template>
  <div class="my-[120vh] mx-bleed">
    <ElementsTitleRevealv2
      :title="'This is a title that animates in a nice way'"
      class="font-display text-6xl uppercase max-w-[10em]"
    />
  </div>
</template>
